import React, { RefObject } from "react";
import { PreviewMeasurement } from "../Models/PreviewMeasurement";
import { StudyModel } from "../Models/StudyModel";
import { DataHelper } from "../Helpers/DataHelper";
import { LargeTTFMCurve } from "./LargeTTFMCurve";
import  PopupWindow from "./PopupWindow";
import { LabelModel } from "../Models/LabelModel";
import CardiacSubwayMap from "../Models/Trigger/CardiacSubwayMap";
import { Graft } from "../Models/Trigger/TriggerClasses";
import { ClusterEvalModel } from "../Models/ClusterEvalModel";
import { AICurveEvalButton } from "./AICurveEvalButton";
import { LargeImagingPlayer } from "./LargeImagingPlayer";
import { InputItem } from "./InputItem";
import { ErrorWindow } from "./ErrorWindow";
import { InfoBox } from "./InfoBox";
import SubwayMap from "../Models/Trigger/SubwayMap";


export class LargePreviewWindow extends React.Component<
    {
        rowData: PreviewMeasurement,
        studySelected: StudyModel,
        dataHelper: DataHelper,
        previewAvailable: boolean,
        context: string, 
        procedureId: string,
        closeClicked: ()=>void,
        onEvaluationResult: (result: ClusterEvalModel) => void,
        cachedEvalResutls:ClusterEvalModel,
        orientationChanged?: (value :string) => void,
        parentRefresh?: () => void
    },
    {
      evaluationResult: ClusterEvalModel
      evalResultDict: ClusterEvalModel,
      otherComments: string,
      busySaving: boolean,
      scrollPositionInDatapoints?: number,
      axisSizeInDatapoints?: number
    }
> {

  errorWindow:  RefObject<ErrorWindow>;
  infoBox: RefObject<InfoBox>;

    constructor(props: any) {
        super(props);
         this.errorWindow = React.createRef();
             this.infoBox = React.createRef();
        this.state = {
          evaluationResult:new ClusterEvalModel(),
          evalResultDict: props.cachedEvalResutls,
          otherComments: props.rowData.otherComments,
          busySaving: false
        }
    }

    static defaultProps = {
        //Set any properties that are optional when creating the component.
        context: "",
        previewAvailable: true
      }

    
    componentDidMount(): void {
        //Put stuff here that you want to run the first time the component is loaded.
    }


    stringToColor(str: string): string {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const hue = (hash*19) % 360;
        return `hsl(${hue}, 80%, 50%)`; // Here, we set the saturation to 100% and lightness to 75%
      }

      onEvalResult = (result: ClusterEvalModel) => {
        this.props.onEvaluationResult(result)
        
        this.setState(prevState => ({
          evalResultDict: {
            ...prevState.evalResultDict,
            [this.props.procedureId]: result
          }
        }))
      }

      saveScrollerPosition = (scrollerPosInSeconds: number, saveSuccess: (success: boolean)=> void, lastMean: number, lastPI: number, lastACI: number, displayRangeMin: number, displayRangeMax: number) =>
      {
          let measurementValue = this.props.rowData;
          measurementValue.sweepPosition = scrollerPosInSeconds;
          measurementValue.savedMean = lastMean;
          measurementValue.savedPI = lastPI;
          measurementValue.savedACI = lastACI;
          measurementValue.displayRangeMin = displayRangeMin;
          measurementValue.displayRangeMax = displayRangeMax;
          let columnChanged = ["sweepPosition", "savedMean", "savedPI", "savedACI", "displayRangeMin", "displayRangeMax"];
          let EmptyProcedure = {
            id: this.props.procedureId,
            measurements: [measurementValue]

          };
              this.props.dataHelper.CallStudyService("SaveProcedure", { studyId: this.props.studySelected.id, previewProcedure: EmptyProcedure, updateMeasurements: true, columnChanged: columnChanged }, {}, (dataOut: string) => {
                             //TODO: Show a success or fail message.
                             // let procParse: PreviewProcedureModel[] = JSON.parse(dataOut);
                             // this.setState({
                             //   procedures: procParse
                             // })
                             if (dataOut)
                             {
                               let showTo = JSON.parse(dataOut);
                               if (showTo === "DONE")
                               {
                                
                                 
                                 if (saveSuccess)
                                 {
                                   saveSuccess(true);
                                 }
                                 if (this.props.parentRefresh)
                                 {
                                    this.props.parentRefresh();
                                 }
                                   
                                 (this.infoBox.current as InfoBox).show("Procedure '" + columnChanged + "' saved");
                               }
                               else
                               {
                                 (this.errorWindow.current as ErrorWindow).show(700, showTo );
                                 if (saveSuccess)
                                    saveSuccess(false);
                               }
             
                             }else
                             {
                               (this.errorWindow.current as ErrorWindow).show(700, dataOut);
                               if (saveSuccess)
                                  saveSuccess(false);
                             
                           }
                           }, (stautus: number, errorMessage: string) => { 
                             
                            if (saveSuccess)
                              saveSuccess(false);
                            (this.errorWindow.current as ErrorWindow).show(stautus, errorMessage);      
                          }
                             , "POST");
      }
    
      saveFieldValue = (measurementIn: PreviewMeasurement, fieldName: string, fieldValue: string) =>
      {
        this.setState({
          busySaving: true
        });
        (measurementIn as any)[fieldName] = fieldValue;
        let columnChanged = [fieldName];
        let EmptyProcedure = {
          id: this.props.procedureId,
          measurements: [measurementIn]

        };
            this.props.dataHelper.CallStudyService("SaveProcedure", { studyId: this.props.studySelected.id, previewProcedure: EmptyProcedure, updateMeasurements: true, columnChanged: columnChanged }, {}, (dataOut: string) => {
                            //TODO: Show a success or fail message.
                            // let procParse: PreviewProcedureModel[] = JSON.parse(dataOut);
                            // this.setState({
                            //   procedures: procParse
                            // })
                            if (dataOut)
                            {
                              let showTo = JSON.parse(dataOut);
                              if (showTo === "DONE")
                                (this.infoBox.current as InfoBox).show("Procedure '" + columnChanged + "' saved");
                              else
                                (this.errorWindow.current as ErrorWindow).show(700, showTo );
            
                            }else
                            {
                              (this.errorWindow.current as ErrorWindow).show(700, dataOut);

                          }
                          
                               this.setState({
                            busySaving: false
                          });
                            
                          }, (stautus: number, errorMessage: string) => { (this.errorWindow.current as ErrorWindow).show(stautus, errorMessage); this.setState({
          busySaving: false
        }); }
                            , "POST");
      }

    render() {
        let fullAnatomicalLocation = this.props.rowData.anatomicalLocations?.join("-") as string;
        if (!fullAnatomicalLocation)
          fullAnatomicalLocation = this.props.rowData.vessels?.join("-") as string;
        
        let suggestedLabels: LabelModel[] = [];
          
        if (this.props.rowData.labels) {
             //Remove label duplicates
           let newLabelList = [];
           let labelsAdded = [];
        for (let index = 0; index < this.props.rowData.labels.length; index++) {
          const element = this.props.rowData.labels[index];
          if (labelsAdded.indexOf(element.id) === -1)
          {
            labelsAdded.push(element.id);
            newLabelList.push(element);
          }
        
        }
        newLabelList.forEach((label: LabelModel) => {
                label.suggestedLabels?.forEach((labelChild: LabelModel) => {
                    suggestedLabels.push(labelChild);
                });
         
          });
        }
        
        // let uniqueLabels = Array.from(new Set(suggestedLabels));
        let labelsStyled = <></>;
        if (suggestedLabels) {
            labelsStyled =
            <div className="tagsWrapper">
              {suggestedLabels.map((label, index) => (
                
                    label.name ?
                    <div key={index} className={"labelInDataGrid"} style={{backgroundColor: this.stringToColor(label.name)}}>
                    {label.name}
                  </div>
                  :<></>

                
               
              ))}
            </div>
        
        }

        let graftsIn: Graft[] = Graft.GenerateGrafts([suggestedLabels as LabelModel[]]);
        if (this.props.rowData.isIntui && this.props.rowData.intuiGraft)
        {
          graftsIn = [ this.props.rowData.intuiGraft];
        }
        let hideWorklist = false;// this.props.studySelected.studyType !== studyTypes.Cardiac;
        let chartWidth = 760;
        if (hideWorklist)
        {
            chartWidth= 960;
        }

        let fullXAxisSize = 1000;
         if (this.props.rowData.isIntui)
            fullXAxisSize = 1000;
        return (
            
            
            <>
                <PopupWindow title={fullAnatomicalLocation} additionalClass="largePreviewWindow" closeClicked={()=>{
                    this.props.closeClicked();
                }}>
                    <div className="previewHolder">
                    <div className={"previewDataHolder " + (hideWorklist ? "fullPreview" : "" )}>
                 
                    {
                 ( this.props.rowData.measurementType === "Flow" ?

                <LargeTTFMCurve saveScrollerPosition={this.saveScrollerPosition} scrubberAdjusted={(newPositionInDatapoints, axisSizeInDatapoints) => { 
                  this.setState({
                  scrollPositionInDatapoints: newPositionInDatapoints,
                  axisSizeInDatapoints: axisSizeInDatapoints
                })}} xAxisMax={fullXAxisSize} meanCutOff1={this.props.studySelected.lowerReferenceValue as number} meanCutOff2={this.props.studySelected.upperReferenceValue as number} parentGroup={this.props.context} height={560} width={chartWidth} studySelected={this.props.studySelected} procedureId={this.props.procedureId} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></LargeTTFMCurve>
             : (
              this.props.rowData.measurementType === "Aux"
            ?
              <LargeTTFMCurve saveScrollerPosition={this.saveScrollerPosition}  xAxisMax={fullXAxisSize} meanCutOff1={this.props.studySelected.lowerReferenceValue as number} color1="#0196C2" color2="#C0E8F2" color3="#2A6BFF" meanCutOff2={this.props.studySelected.upperReferenceValue as number} parentGroup={this.props.context} height={560} width={chartWidth}  yAxisVisible={true} procedureId={this.props.procedureId} xAxisVisible={true} usefilling={false} subType="Aux" studySelected={this.props.studySelected} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></LargeTTFMCurve>
            : (
           this.props.rowData.measurementType === "Ecg"
            ?
              <LargeTTFMCurve saveScrollerPosition={this.saveScrollerPosition}  xAxisMax={fullXAxisSize} meanCutOff1={this.props.studySelected.lowerReferenceValue as number} color1="#0196C2" color2="#C0E8F2" color3="#2A6BFF" meanCutOff2={this.props.studySelected.upperReferenceValue as number} parentGroup={this.props.context} height={560} width={chartWidth}  yAxisVisible={true} procedureId={this.props.procedureId} xAxisVisible={true} usefilling={false} subType="Ecg" studySelected={this.props.studySelected} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></LargeTTFMCurve>
            :
            (this.props.rowData.measurementType === "Imaging"
            ?
                <LargeImagingPlayer orientationChanged={this.props.orientationChanged} studySelected={this.props.studySelected} procedureId={this.props.procedureId} dataHelper={this.props.dataHelper} rowData={this.props.rowData} closeClicked={()=>{}}></LargeImagingPlayer>
            
            : (
              this.props.rowData.measurementType === "PWDopplers" || this.props.rowData.measurementType === "PWDoppler"
               ?
                 <LargeTTFMCurve saveScrollerPosition={this.saveScrollerPosition}  xAxisMax={fullXAxisSize/2} meanCutOff1={this.props.studySelected.lowerReferenceValue as number} meanCutOff2={this.props.studySelected.upperReferenceValue as number} parentGroup={this.props.context} height={560} width={chartWidth}  color1="#4A90E2" yAxisVisible={true} procedureId={this.props.procedureId} xAxisVisible={true} usefilling={false} subType="PWDopplers" studySelected={this.props.studySelected} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></LargeTTFMCurve>
               :(this.props.rowData.measurementType === "TransitTrend"
               ?
                 <LargeTTFMCurve saveScrollerPosition={this.saveScrollerPosition}  xAxisMax={fullXAxisSize} meanCutOff1={this.props.studySelected.lowerReferenceValue as number} meanCutOff2={this.props.studySelected.upperReferenceValue as number} parentGroup={this.props.context} height={560} width={chartWidth}  color1="#4A90E2" yAxisVisible={true} procedureId={this.props.procedureId} xAxisVisible={true} usefilling={false} subType="TransitTrend" studySelected={this.props.studySelected} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></LargeTTFMCurve>
               :<></>))
                 ))))
                    }
                    <div className="previewOptions">
                      
                       <InputItem name="ProtocolStep" title="Protocol Step" type="dropdown"  options={["Select"].concat(this.props.studySelected.protocolSteps as string[])} value={this.props.rowData.protocolStep} onChange={(name, value) =>
                        {
                          this.saveFieldValue(this.props.rowData, "protocolStep", value);
                        }
                       }></InputItem>
                    </div>
                       </div>
                       {
                        hideWorklist ?
                        <></>
                        :
                        <div className="previewWorklistHolder">
                          <div className="worklistTop">
                            {(this.props.rowData.measurementType==="Flow" ? 
                              <div className="referencevalues">
                                <h4>Reference Values:</h4>
                                <div className="refvalwrap">
                                  <div className={!this.props.rowData.indicesColorGraded ? "configselected" : ""}>Case Cloud</div>
                                  <div className={this.props.rowData.indicesColorGraded ? "configselected" : ""}>Intui</div>
                                </div>
                                
                              </div> : <></>)}
                                          <h4>Anatomic location:</h4>
                        {
                            graftsIn.length > 0 ?
                            (this.props.studySelected.studyType === "Cardiac" ?
                            <CardiacSubwayMap parentProcedure={null as any} protocolSteps={[]} showeditbutton={false}  CurrentItem={graftsIn[0]}  showSelected={true} showsaves={false}></CardiacSubwayMap>
                            :
                            <SubwayMap CurrentItem={graftsIn[0]} Context={""} customGraftText={""} index={0} commentToggled={function (e: boolean): void {
                                throw new Error("Function not implemented.");
                            } } measurementSelectionOpen={false} measurementSelectionSelected={function (e: boolean): void {
                                throw new Error("Function not implemented.");
                            } } tileColorOn={true} ></SubwayMap>)
                            :
                            labelsStyled
                        }
                    </div>
                    <div className="worklistBottom">
                        <div className="commentsBox">
                          <h4>Comments:</h4>
                        <textarea className="commentsText" value={this.state.otherComments} onChange={(e) =>
                          {
                              this.setState({otherComments: e.currentTarget.value});
                          }
                        }></textarea>
                        <button className={"primaryButton intuiButton "  + (this.state.busySaving ? "saving" : "")} onClick={()=>{
                            this.saveFieldValue(this.props.rowData, "otherComments", this.state.otherComments);
                          }}>Save comment</button>
                        </div>
                      
                      </div>
                      {(this.props.rowData.measurementType==="Flow" && this.props.studySelected.curveEvalEnabled )? (
                       <AICurveEvalButton axisSizeInDatapoints={this.state.axisSizeInDatapoints} scrollPositionInDatapoints={this.state.scrollPositionInDatapoints} evaluationResult={this.props.cachedEvalResutls?? new ClusterEvalModel()} dataHelper={this.props.dataHelper} rowData={this.props.rowData} onEvaluationResult={this.onEvalResult} studySelected={this.props.studySelected} procedureId={this.props.procedureId}></AICurveEvalButton>):<></>}
                       
                       </div>
                       }
                    </div>
                </PopupWindow>
                      <ErrorWindow ref={this.errorWindow}></ErrorWindow>
                  <InfoBox ref={this.infoBox} title="Confirmation" type="confirmation"></InfoBox>
            </>
        );
    }
}


